module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-tremezzo-salice.90cd82e7.jpg";